import styled from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  width: 100%;
  height: 100%;
  border: 1px solid #F4F5F6;
  border-radius: 24px;
  background-color: #fff;
  margin: 12px;

  ${media.lessThan('small')`
    margin: 0px;
  `}
`
